import { FC } from 'react';

import { useParams, useLocation, useNavigate } from 'react-router-dom';

import { useGetArticleData } from 'hooks/useGetArticleData';
import { usePageTitle } from 'hooks/usePageTitle';
import { useRemoveRubyTags } from 'hooks/useRemoveRubyTags';

import { Button } from 'components/parts/Button';

import styles from './ClueResult.module.scss';

export const ClueResult: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  const queryParams = new URLSearchParams(location.search);
  const no = queryParams.get('no') || '1';
  const article = useGetArticleData(id || '');
  usePageTitle(useRemoveRubyTags(article?.name));
  console.log(article?.name);

  function getClueCardFileName() {
    return `${String(id).padStart(3, '0')}_clue_${String(no).padStart(1, '0')}.webp`;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.body}>
          <p className={styles.message}>
            <strong data-clue={no}>手がかり{no}</strong>を手に入れた！
          </p>
          <div className={styles.imageWrap}>
            <img
              src={require(`images/character/chara-clear-top.webp`)}
              alt=""
              className={styles.chara}
            />

            <img
              src={require(`components/pages/Area/images/${getClueCardFileName()}`)}
              alt={`手がかり${no}`}
              className={styles.image}
            />
          </div>
          <div className={styles.action}>
            <Button
              text="探索エリアに戻る"
              styleType="secondary"
              handleClick={() => navigate(`/area/${id}`)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
